import React from 'react';
import LocationTemplate from './LocationTemplate';

const GarlandPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Garland"
      stateName="North Carolina"
      countyName="Sampson"
      zipCodes={["28441"]}
      latitude={34.7878}
      longitude={-78.3941}
      population={610}
      historicalFact="Incorporated in 1907, named for the Garland family."
      nearbyTowns={[
        "Clinton, NC",
        "Turkey, NC",
        "Roseboro, NC",
        "Salemburg, NC",
        "Newton Grove, NC",
        "Harrells, NC",
        "Autryville, NC",
        "Godwin, NC"
      ]}
    />
  );
};

export default GarlandPage;